<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" color="primary">
      <inline-svg :src="require('@/assets/svg/thumb_up.svg')" width="25" />
      Accept Role
    </SecondaryButton>
    <AcceptBookingDialog :isOpen="isOpen" @close="closeDialog" />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import AcceptBookingDialog from "@/views/bookings/components/ConfirmDialogs/AcceptBookingDialog";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "AcceptBookingAction",
  components: {
    BaseAction,
    AcceptBookingDialog,
    SecondaryButton,
    InlineSvg
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
